module.exports = ".top-box-program-status-link {\r\n  cursor: pointer;\r\n}\r\n\r\n  .top-box-program-status-link:hover {\r\n    color: #4b80e0 !important;\r\n  }\r\n\r\n  .cal-font {\r\n  color: darkgrey;\r\n  font-size: 13px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/remaining-earnings/remaining-earnings.component.css
// module id = ./src/app/components/remaining-earnings/remaining-earnings.component.css
// module chunks = main